import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const IMAGES = [
  { src: "/images/studio-7.webp", alt: "Vison Studios stacked daisy caps" },
  { src: "/images/studio-6.webp", alt: "Vison Studios pink daisy cap at the mood board" },
  { src: "/images/studio-8.webp", alt: "Vison Studios daisy cutout on a trucker cap" },
  { src: "/images/studio-1.webp", alt: "Daisy cap in the Vison Studios workshop" },
  { src: "/images/studio-2.webp", alt: "Stack of Vison daisy trucker caps" },
  { src: "/images/studio-3.webp", alt: "Laser-cut daisy pieces on the studio table" },
  { src: "/images/studio-4.webp", alt: "Sewing a daisy patch in the studio" },
  { src: "/images/studio-5.webp", alt: "Daisy patches on a black cap brim" },
];

export default function Gallery() {
  const [index, setIndex] = useState(0);
  const next = () => setIndex((i) => (i + 1) % IMAGES.length);
  const prev = () => setIndex((i) => (i - 1 + IMAGES.length) % IMAGES.length);

  const handleDragEnd = (_e, info) => {
    if (info.offset.x < -60 || info.velocity.x < -400) next();
    else if (info.offset.x > 60 || info.velocity.x > 400) prev();
  };

  return (
    <motion.main
      data-testid="gallery-page"
      className="pt-14"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="relative w-full">
        <div className="relative overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.img
              key={IMAGES[index].src}
              src={IMAGES[index].src}
              alt={IMAGES[index].alt}
              data-testid="gallery-image"
              className="h-[calc(100dvh-3.5rem)] w-full cursor-grab touch-pan-y object-cover active:cursor-grabbing lg:h-[calc(100dvh-9rem)] lg:object-contain"
              initial={{ opacity: 0, x: 24 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -24 }}
              transition={{ duration: 0.35, ease: "easeOut" }}
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              dragElastic={0.25}
              onDragEnd={handleDragEnd}
              draggable="false"
            />
          </AnimatePresence>
          <button
            type="button"
            aria-label="Previous image"
            data-testid="gallery-prev-button"
            onClick={prev}
            className="absolute left-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-neutral-900/80 text-white transition-colors hover:bg-neutral-900"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button
            type="button"
            aria-label="Next image"
            data-testid="gallery-next-button"
            onClick={next}
            className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-neutral-900/80 text-white transition-colors hover:bg-neutral-900"
          >
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
        <p
          data-testid="gallery-counter"
          className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2 rounded-full bg-white/80 px-3 py-1 text-xs text-neutral-600 backdrop-blur-sm"
        >
          {index + 1} / {IMAGES.length}
        </p>
      </div>
    </motion.main>
  );
}
